import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { FilterProvider } from "./context/GlobalFilterContext";
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
//import 'bootstrap/dist/js/bootstrap.js';
//import * as bootstrap from 'bootstrap';
import './css/index.css';
import './css/navigation.css';
import './css/forms.css';
import './css/tables.css';
import './css/views.css';
import './css/ui.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <FilterProvider>
    <App />
  </FilterProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
